import { render, staticRenderFns } from "./stuContact.vue?vue&type=template&id=bfafff40&scoped=true&"
import script from "./stuContact.vue?vue&type=script&lang=js&"
export * from "./stuContact.vue?vue&type=script&lang=js&"
import style0 from "./stuContact.vue?vue&type=style&index=0&id=bfafff40&prod&lang=less&"
import style1 from "./stuContact.vue?vue&type=style&index=1&id=bfafff40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafff40",
  null
  
)

export default component.exports